import React from "react";
import { SidePanel } from "@mwt/side-panel";
import { Flex } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

import { ConnectedCamSelectDropdown } from "../results-device-select-dropdown/ConnectedCamSelectDropdown";
import { ConnectedMicSelectDropdown } from "../results-device-select-dropdown/ConnectedMicSelectDropdown";
import { ConnectedSpeakerSelectDropdown } from "../results-device-select-dropdown/ConnectedSpeakerSelectDropdown";

import { SidePanelButton } from "./results-open-side-panel-button/SidePanelButton";
import { ResultsSidePanelProps } from "./ResultsSidePanel.types";
import { useSidePanelStyles } from "./ResultsSidePanel.styles";

export const ResultsSidePanel: React.FC<ResultsSidePanelProps> = ({
  openSidePanel,
  closeSidePanel,
  isSidePanelOpen,
  isInfoFetched,
}) => {
  const sidePanelStyles = useSidePanelStyles();
  const { t } = useTranslation();

  return (
    <SidePanel
      open={isSidePanelOpen}
      styles={sidePanelStyles.sidePanel}
      side="right"
      backdrop={false}
      header={t("DEVICE_SETTINGS")}
      content={
        <Flex
          column
          gap="gap.large"
          vAlign="end"
          styles={sidePanelStyles.dropdownContainer}
        >
          <ConnectedCamSelectDropdown label={t("CAMERA_TITLECASE")} />
          <ConnectedMicSelectDropdown label={t("MICROPHONE_TIELECASE")} />
          <ConnectedSpeakerSelectDropdown label={t("SPEAKER_TITLECASE")} />
        </Flex>
      }
      closeOnOutsideClick={true}
      cancelButton={{
        styles: sidePanelStyles.closeButton,
        content: t("CLOSE"),
      }}
      onCancel={closeSidePanel}
      trigger={
        <SidePanelButton
          togglePanelOpen={openSidePanel}
          isInfoFetched={isInfoFetched}
        />
      }
    />
  );
};
